import _ from "lodash";
/**--external-- */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
/**--internal-- */
import { graphModes } from "Worksheet/modules/WorksheetConstants";
import classes from "./GraphQuestion.scss";
import Graph from "UIComponents/Graph";
import update from "immutability-helper";

class GraphQuestion extends PureComponent {
  constructor(props) {
    super(props);
    if (props.customRef) {
      props.customRef(this);
    }
  }

  updateGraphData = (dataUrl, thumbUrl, type) => {
    const { updateInputField, fieldKey } = this.props;

    const currentValues = _.get(this.props, "value", {}) ?? {};

    let oldUrls = _.get(currentValues, "oldUrls", []);
    let oldThumbUrls = _.get(currentValues, "oldThumbUrls", []);

    if (_.get(currentValues, "url", "")) {
      oldUrls = _.concat(oldUrls, _.get(currentValues, "url", ""));
    }

    if (_.get(currentValues, "thumbUrl", "")) {
      oldThumbUrls = _.concat(
        oldThumbUrls,
        _.get(currentValues, "thumbUrl", "")
      );
    }

    const params = update(currentValues, {
      $merge: {
        url: dataUrl,
        thumbUrl: thumbUrl,
        oldUrls: oldUrls,
        oldThumbUrls: oldThumbUrls,
        type: type,
      },
    });

    updateInputField?.({
      params: {
        [fieldKey]: params,
      },
      isMutation: true,
    });
  };
  getConfig = (
    mode,
    allowInteraction,
    allowAlgebra,
    resourceId,
    isSubQuestion,
    questionId,
    subQuestionParentId,
    questionIndex
  ) => {
    return {
      showGraphDropdown: _.includes(["create"], mode),
      enableViewQuestion: !_.includes(["create"], mode),
      showEditGraphOption:
        _.includes(["evaluate"], mode) ||
        _.includes(["create"], mode) ||
        (_.includes(["create", "edit", "preview"], mode) && allowInteraction),
      hideTitleBarPanel: _.includes(["edit", "view", "preview"], mode),
      allowAlgebraView:
        _.includes(["evaluate", "create"], mode) ||
        (allowAlgebra && _.includes(["edit"], mode)),
      showSaveButton:
        _.includes(["evaluate"], mode) ||
        _.includes(["create"], mode) ||
        (_.includes(["create", "edit"], mode) && allowInteraction),
      fixGraphOnSave: _.includes(["create"], mode),
      disableFixedGraph: _.includes(["create", "evaluate"], mode),
      subQuestionParentId,
      resourceId,
      isSubQuestion,
      questionId,
      questionIndex,
    };
  };
  renderHeader = () => {
    const { mode, t } = this.props;
    switch (mode) {
      case "create": {
        return (
          <div className={classes.headerContainer}>
            <div className={classes.leftContainer}>
              <div className="text-label-2">{t("worksheet:graph")}</div>
            </div>
          </div>
        );
      }
      default:
        return null;
    }
  };

  renderContent = () => {
    const {
      mode,
      allowInteraction,
      allowAlgebra,
      value,
      questionIndex,
      subQuestionParentId,
      resourceId,
      isSubQuestion,
      questionId,
      worksheetMode,
      isFromInternalTool,
    } = this.props;
    const config = this.getConfig(
      mode,
      allowInteraction,
      allowAlgebra,
      resourceId,
      isSubQuestion,
      questionId,
      subQuestionParentId,
      questionIndex
    );
    return (
      <Graph
        mode={mode}
        value={value}
        allowInteraction={allowInteraction}
        allowAlgebra={allowAlgebra}
        updateGraphData={this.updateGraphData}
        config={config}
        worksheetMode={worksheetMode}
        isFromInternalTool={isFromInternalTool}
        testId={"worksheet"}
      />
    );
  };

  render() {
    return (
      <div className={classes.container}>
        {this.renderHeader()}
        {this.renderContent()}
      </div>
    );
  }
}

GraphQuestion.displayName = "GraphQuestion";

GraphQuestion.propTypes = {
  labelComponent: PropTypes.element,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  mode: PropTypes.oneOf(graphModes),

  updateInputField: PropTypes.func,
  fieldKey: PropTypes.string,
  allowInteraction: PropTypes.bool,
  allowAlgebra: PropTypes.bool,
  questionIndex: PropTypes.string,
  isSubQuestion: PropTypes.bool,
  resourceId: PropTypes.string,
  questionId: PropTypes.string,
};

export default GraphQuestion;
